/*
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-28 13:32:38
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-16 16:21:01
 */
import { defineStore } from 'pinia';
import {
    UsdtPrefixCurrencyInitState,
    profileCurrenciesResponseState,
    type ProfileCurrenciesResponseState,
    type UsdtPrefixCurrency,
} from '~/socket/profile/dto';
import { useProfileSocket } from '~/socket/profile';

type stateType = Partial<{
    comparisonCurrencyList: ProfileCurrenciesResponseState;
    usdtComaparisonCurrencyList: UsdtPrefixCurrency;
}>;
export const useRatesStore = defineStore('rates', {
    state: () => ({
        comparisonCurrencyList: profileCurrenciesResponseState,
        usdtComaparisonCurrencyList: UsdtPrefixCurrencyInitState,
    }),
    actions: {
        setState(partialState: stateType) {
            const aNewRates = Object.entries(partialState);
            aNewRates.forEach(aCur => {
                const [key, val] = aCur;
                Object.assign(this[key], val);
            });
        },
        /**
         * 初始化
         * @returns 成功状态
         */
        async initData(
            iTimeoutMs=0,
        ){
            const {oPromise, resolve, reject} = createPromise();
            const t01 = Date.now();
            let timer01 = null;
            useProfileSocket().EMIT_PROFILE_GETCURRENCIES((res)=>{
                if (import.meta.dev){
                    console.log('汇率查询完毕，耗时ms：', Date.now() - t01); // ≈10ms
                }
                clearTimeout(timer01);
                const result = {};
                Object.entries(res).forEach(([key, value]) => {
                    if (key.startsWith('usdt')) {
                        result[key] = value;
                    }
                });
                this.setState({
                    comparisonCurrencyList: res,
                    usdtComaparisonCurrencyList: result as any,
                });
                resolve({success: true});
            });
            if (iTimeoutMs > 0){
                const t01 = Date.now();
                timer01 = setTimeout(()=>{
                    console.warn('查询汇率超时 used:', Date.now() - t01); 
                    resolve({success: false, msg: '查询汇率超时'});
                }, iTimeoutMs);
            }
            return oPromise;
        },
    },
    getters: {
        getState: (state) => state,
        // ↓ 返回当前币种的汇率（暂时没用到）
        nRate: (state) => (currency: string) => {
            const sKey = `usdt${currency}`;
            const oneUSD2TargetCurrency = state.usdtComaparisonCurrencyList[sKey];
            // console.log("1美元可兑换当前币种的金额:", oneUSD2TargetCurrency);
            return oneUSD2TargetCurrency;
        },
    },
});

